import { Component, Input, OnInit } from '@angular/core';
import { apiService } from 'src/app/service/api.service';
import { JardinModel } from 'src/app/model/Jardin.model';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { PreviewComponent } from 'src/app/components/preview/preview.component';

@Component({
  selector: 'app-medicion-satisfaccion',
  templateUrl: './medicion-satisfaccion.component.html',
  styleUrls: ['./medicion-satisfaccion.component.css']
})
export class MedicionSatisfaccionComponent implements OnInit {
  @Input() simulacion: boolean;
  dataJardin = new JardinModel();
  constructor( private api: apiService,
    public dialog: MatDialog,) { }

  apiEndpoint = environment.apiEndpoint;

  ngOnInit(): void {
     this.dataJardin = this.api.dataJardin;
  }

  verDocumentoJardin(){

    let urlDoc = this.apiEndpoint + "jardin/imprimirMedicionSatisfaccion/" + this.dataJardin.idJardinPeriodo;

    this.verArchivo(urlDoc,'satisfaccion.pdf');
  }

    public verArchivo(path : string, realName : string): void {
  
        const dialogRef = this.dialog.open(PreviewComponent, {
        disableClose: true,
            data: {file: path, name: realName }
        });
    }

}
